import styles from './index.module.less'
import START from '@/assets/image/gea/start.png'
import { useTranslation } from 'react-i18next'
import { Dropdown, QRCode, Tooltip } from 'antd'
import AddressHash from '@/components/AddressHash'
import { useState } from 'react'
import { IResModuleAccountDetailType } from '@/api/moduleAccount/interface'
import { useRequest } from 'ahooks'
import { getModuleAccountDetail } from '@/api/moduleAccount'
import { getCheckInCount } from '@/api/account'
import { ugeaToGea2, ugagToGag, formatDecimalCus, removeTrailingZeros } from '@/utils/number'
import { useParams } from 'react-router-dom'
import useMeNavigate from '@/hooks/useMeNavigate'
import { isEmptyOrNil } from '@/utils'
import MeToolTip from '@/components/MeToolTip'
import classNames from 'classnames'

const Index = () => {
  const { t } = useTranslation()
  const navigate = useMeNavigate()
  const { address } = useParams()
  const [accountDetail, setAccountDetail] = useState<IResModuleAccountDetailType>()
  const [checkInCount, stCheckInCount] = useState(0)
  useRequest(() => getModuleAccountDetail(address!), {
    refreshDeps: [address],
    onSuccess: (res) => {
      if (res?.isModuleAccount) {
        navigate(`/moduleAccount/${res.address}`, { replace: true })
        return
      }
      setAccountDetail(res)
    },
  })

  useRequest(() => getCheckInCount(address!), {
    refreshDeps: [address],
    onSuccess: (res) => {
      stCheckInCount(res?.checkin_count?.aggregate?.count || 0)
    },
  })

  const getRegionName = (value: string) => {
    if (isEmptyOrNil(value)) return '-'
    const node = value.toUpperCase()
    if (node.endsWith('_VILLAGE')) {
      return t('explorer_266')
    }
    return node
  }

  return (
    <div className={styles.wrap}>
      <div className="base_info">
        <div className="qr_box">
          <QRCode bordered={false} size={200} value={address!} color={'#08C284'} />
          <div className="info_box">
            <div className="info_box_item">
              {/* 地址 */}
              <span className="name">{t('explorer_114')}:</span>
              <AddressHash
                className={styles.address_hash_cus}
                data={address!}
                copyIcon={'gray'}
              ></AddressHash>
            </div>
            {/* 邀请地址 */}
            {/* <div className="info_box_item"> */}
            {/* <Dropdown
                menu={{
                  items: [
                    {
                      key: '1',
                      label: (
                        <AddressHash
                          data={accountDetail?.inviter || ''}
                          copyIcon={'gray'}
                          handleJump={() => {
                            navigate(`/accountDetail/${accountDetail?.inviter}`)
                          }}
                        ></AddressHash>
                      ),
                    },
                  ],
                }}
                trigger={['click']}
              >
                <div style={{ cursor: 'pointer' }}>
                  <span className="name">{t('explorer_199')}</span>
                  <span className="address-sword"></span>
                </div>
              </Dropdown> */}
            {/* <Tooltip
                trigger={'click'}
                placement="bottomLeft"
                className={styles.tooltip_cus}
                style={{ width: 'fit-content' }}
                overlayStyle={{ width: 'fit-content', maxWidth: '90vw' }}
                title={
                  <AddressHash
                    data={accountDetail?.inviter || ''}
                    copyIcon={'gray'}
                    handleJump={() => {
                      navigate(`/accountDetail/${accountDetail?.inviter}`)
                    }}
                  ></AddressHash>
                }
                color="#fff"
              >
                <div style={{ cursor: 'pointer' }}>
                  <span className="name">{t('explorer_199')}</span>
                  <span className="address-sword"></span>
                </div>
              </Tooltip> */}
            {/* </div> */}
            <div className="info_box_item_wrap">
              {/* 所属国家/区 */}
              <div className="info_box_item vertically_centered">
                <span className="name">{t('explorer_200')}:</span>
                <span className="font_14">
                  {getRegionName(accountDetail?.regionId as string) || '-'}
                </span>
              </div>
              <div className="info_box_item vertically_centered">
                {/* 等级 */}
                <span className="name">{t('explorer_201')}:</span>
                <span>
                  {Number(accountDetail?.starLevel || 0)
                    ? Array(Number(accountDetail?.starLevel))
                        .fill(1)
                        .map((_, index) => <img key={index} className="start_img" src={START} />)
                    : '-'}
                </span>
              </div>
            </div>
            <div className="info_box_item_wrap">
              <div className="info_box_item vertically_centered">
                {/* 累计签到次数 */}
                <span className="name">{t('explorer_163')}:</span>
                <span className="font_14">{checkInCount}</span>
              </div>

              <div className="info_box_item vertically_centered">
                <span className="name">
                  <MeToolTip className="font_14" title={'Seed ID'} tip={t('explorer_262')} />
                </span>
                <span className={'font_14'}>{accountDetail?.did || '-'}</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="sub_info_card">
            <div className="sub_info_card_item">
              {/* 999999999999196902262860 */}
              <span className="title">GEA</span>
              <span className="content font_14">
                {ugeaToGea2(accountDetail?.UgeaAmount, false, 8).value}
              </span>
            </div>
            <div className="sub_info_card_item">
              <span className="title">GAG</span>
              <span className="content font_14">{ugagToGag(accountDetail?.UgagAmount).value}</span>
            </div>
            <div className="sub_info_card_item">
              <span className="title">
                <MeToolTip className="font_14" title={'ANS'} tip={t('explorer_261')} />
              </span>
              <span className="content font_14">
                {removeTrailingZeros(formatDecimalCus(accountDetail?.TotalAns ?? '', 8))}{' '}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="pled_geinformation">
        {/* 质押信息 */}
        <div className="title">{t('explorer_68')}</div>
        <div className="content_box">
          <div className="content_box_area_a">
            <span className="name font_14">AGS:</span>
            <div>
              <span>{ugeaToGea2(accountDetail?.delegateCount?.agsAmount).value}</span>
              <span
                className={classNames({
                  unit_text: true,
                  GEA_GAG_box: ugeaToGea2(accountDetail?.delegateCount?.agsAmount).sigin,
                  font_14: true,
                })}
              >
                {ugeaToGea2(accountDetail?.delegateCount?.agsAmount).sigin}
              </span>
            </div>
          </div>
          <div className="content_box_area_b">
            <span className="name font_14">AGD:</span>
            <div>
              <span>{ugeaToGea2(accountDetail?.delegateCount?.agdAmount).value}</span>
              <span
                className={classNames({
                  unit_text: true,
                  GEA_GAG_box: ugeaToGea2(accountDetail?.delegateCount?.agdAmount).sigin,
                  font_14: true,
                })}
              >
                {ugeaToGea2(accountDetail?.delegateCount?.agdAmount).sigin}
              </span>
            </div>
          </div>
          <div className="content_box_area_c">
            <span className="name font_14">AGE:</span>
            <div>
              <span>{ugeaToGea2(accountDetail?.delegateCount?.ageAmount).value}</span>
              <span
                className={classNames({
                  unit_text: true,
                  GEA_GAG_box: ugeaToGea2(accountDetail?.delegateCount?.ageAmount).sigin,
                  font_14: true,
                })}
              >
                {ugeaToGea2(accountDetail?.delegateCount?.ageAmount).sigin}
              </span>
            </div>
          </div>
          <div className="content_box_area_d">
            <span className="name font_14">AGR:</span>
            <div>
              <span>{ugeaToGea2(accountDetail?.delegateCount?.agrAmount).value}</span>
              <span
                className={classNames({
                  unit_text: true,
                  GEA_GAG_box: ugeaToGea2(accountDetail?.delegateCount?.agrAmount).sigin,
                  font_14: true,
                })}
              >
                {ugeaToGea2(accountDetail?.delegateCount?.agrAmount).sigin}
              </span>
            </div>
          </div>
          <div className="withdrawableReward_box content_box_area_e">
            <span className="name font_14">{t('explorer_202')}:</span>
            <div className="font_14">
              <span>{ugeaToGea2(accountDetail?.delegateCount?.withdrawableReward).value}</span>
              <span
                className={classNames({
                  unit_text: true,
                  GEA_GAG_box: ugeaToGea2(accountDetail?.delegateCount?.withdrawableReward).sigin,
                })}
              >
                {ugeaToGea2(accountDetail?.delegateCount?.withdrawableReward).sigin}
              </span>
            </div>

            <div className="withdrawableReward_gag">
              <span className="font_14">
                {ugagToGag(accountDetail?.delegateCount?.withdrawableReward).value}
              </span>
              <span
                className={classNames({
                  unit_text: true,
                  GEA_GAG_box: ugagToGag(accountDetail?.delegateCount?.withdrawableReward).sigin,
                  font_14: true,
                })}
              >
                {ugagToGag(accountDetail?.delegateCount?.withdrawableReward).sigin}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Index
